export type InViewOptions = {
  selector: string;
  threshold?: number;
  rootMargin?: string;
  once?: boolean;
};

export default async function inView({
  selector,
  threshold = 0.25,
  rootMargin = '-20% 0px',
  once = false,
}: InViewOptions) {
  const targets = document.querySelectorAll<HTMLElement>(selector);

  targets.forEach((target) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            target.classList.add('in-view');
            if (once) {
              observer.unobserve(target);
            }
          } else {
            target.classList.remove('in-view');
          }
        });
      },
      { threshold, rootMargin },
    );

    observer.observe(target);
  });
}
